import { WidgetProps } from '@rjsf/utils';
import styled from '@emotion/styled';
import { Button } from '@mui/material';
import Modal from '@/components/_common/Modal/Modal';
import { PolarisIcon } from '@/exports/columnCommonComponents';
import { TerritoryState } from '@/components/_common/SchemaForm/Widgets/TerritoriesWidget/TerritoriesWidget';
import TerritoriesList from './TerritoryList';

type TerritoriesSelectionModalProps = {
  isOpen: boolean;
  selectedTerritories: TerritoryState[];
  onSelectedTerritoriesUpdate: (territories: TerritoryState[]) => void;
  onSubmit: () => void;
  onClose: () => void;
  formData: any;
} & Pick<WidgetProps, 'value' | 'registry'>;

const TerritoriesSelectionModal = ({
  isOpen,
  selectedTerritories,
  value,
  registry,
  onSelectedTerritoriesUpdate,
  onSubmit,
  onClose,
  formData
}: TerritoriesSelectionModalProps) => {
  return (
    <Modal open={isOpen} title="Select Territory" onClose={onClose}>
      <Content>
        <TerritoriesList
          registry={registry}
          selectedTerritories={selectedTerritories}
          onSelectedTerritoriesUpdate={onSelectedTerritoriesUpdate}
          formData={formData}
        />
        <ButtonsContainer>
          <Button variant="text" color="default" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="contained" endIcon={<PolarisIcon icon="right" />} onClick={onSubmit}>
            {value.length > 0 ? 'Update' : 'Add'} Territories
          </Button>
        </ButtonsContainer>
      </Content>
    </Modal>
  );
};

export default TerritoriesSelectionModal;

const Content = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2)
}));

const ButtonsContainer = styled.div(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  paddingTop: theme.spacing(2),
  gap: theme.spacing(2)
}));
